import React from 'react'
import { createSelector } from 'reselect'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Chip } from '@material-ui/core'
import CurrencyFormat from 'react-currency-format'

//HELPERS
import { formatUrlToSlug, stringToSlug } from '../../utils/helpers'

//REDUX

import {
  makeSelectHasSlug,
  makeSelectAgency,
} from '../../redux/ducks/experiences'

const stateSelector = createSelector(
  [makeSelectHasSlug, makeSelectAgency],
  (hasSlug, agency) => ({
    hasSlug,
    agency,
  }),
)

const ExperienceList = ({ experience, isMock, isOpen }) => {
  const { hasSlug, agency } = useSelector(stateSelector)

  const {
    principalImage,
    category,
    name,
    description,
    valuePerPerson,
    key: experienceId,
    agencyKey: agencyId,
  } = experience
  const useStyles = makeStyles((theme) => ({
    imgContainer: {
      backgroundImage: `url(${principalImage})`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      minWidth: '200px',
      height: '150px',
      marginRight: '1rem',
    },
    chipStyle: {
      backgroundColor: isOpen ? '#3ab753' : '#b73a3a',
      color: '#ffffff',
      fontWeight: 'bold',
    },
  }))
  const classes = useStyles()

  const typePrice = () => {
    if (category === 'HOTEL') {
      return ' por noche'
    } else {
      return ' por reserva'
    }
  }

  return (
    <>
      {isMock ? (
        <div className="cardContainer">
          <Box display="flex">
            <div className={classes.imgContainer}></div>
            <Box>
              <h3
                style={{
                  margin: '0',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {name}
              </h3>

              <p className="despcription line-clamp">{description}</p>

              {category !== 'RESTAURANT' ? (
                <>
                  <CurrencyFormat
                    value={valuePerPerson}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                    className="price"
                  />
                  <span>{typePrice()}</span>
                </>
              ) : (
                <Chip
                  size="small"
                  className={classes.chipStyle}
                  label={isOpen ? 'Abierto' : 'Cerrado'}
                />
              )}
            </Box>
          </Box>
        </div>
      ) : (
        <Link
          style={{ textDecoration: 'none', color: 'black' }}
          to={
            hasSlug
              ? `/${agency.agencyUrl}/${formatUrlToSlug(name)}`
              : `/${agencyId}/${experienceId}/${stringToSlug(name)}`
          }
          target="_blank"
        >
          <div className="cardContainer">
            <Box display="flex">
              <div className={classes.imgContainer}></div>
              <Box>
                <h3
                  style={{
                    margin: '0',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {name}
                </h3>

                <p className="despcription line-clamp">{description}</p>

                {category !== 'RESTAURANT' ? (
                  <>
                    <CurrencyFormat
                      value={valuePerPerson}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      className="price"
                    />
                    <span>{typePrice()}</span>
                  </>
                ) : (
                  <Chip
                    size="small"
                    className={classes.chipStyle}
                    label={isOpen ? 'Abierto' : 'Cerrado'}
                  />
                )}
              </Box>
            </Box>
          </div>
        </Link>
      )}
    </>
  )
}

export default ExperienceList
